export default __webpack_public_path__ + "static/media/redWatsapp.822d8c16.jpg";